import isEmpty from 'lodash/isEmpty';
import { conditionCheckByType } from './conditionCheckByType';

export function checkConditions(conditionProfile, conditions) {
  if (!conditions || conditions.length <= 0) {
    return true;
  }

  const profile = isEmpty(conditionProfile) ? {} : conditionProfile;
  return !conditions.find((condition) => conditionCheckByType(profile, condition) !== true);
}
